@if (isLoading()) {
  <div class="or-mt-12-px or-mx-16-px">
    @for (item of skeletonItems; track item) {
      <div class="invitation-skeleton or-skeleton-animated or-mb-12-px"></div>
    }
  </div>
} @else if (invitations()?.length) {
  @for (game of invitations(); track game.gameId) {
    <div
      (click)="goToDetails(game.gameId)"
      class="or-mb-12-px or-mt-12-px invite-card-gradient or-mx-16-px or-p-12-px border-radius-8">
      <div class="or-text-sm or-color-secondary-4">{{ game.host?.displayName }} zaprasza Cię do gierki!</div>
      <div class="or-head-md or-color-white or-my-4-px">{{ game.gameName }}</div>
      <div class="or-text-md or-color-white">{{ game.formattedDate }}</div>
      <div (click)="stopEventPropagation($event)" class="or-mt-16-px">
        <button
          preventMultiClick
          class="button-primary-style or-h-24-px or-head-xs or-w-112-px or-mr-12-px border-shade"
          [sendApplication]="game.gameId"
          (click)="trackAccept(game.gameId)"
          (applicationSent)="refresh()">
          Gram!
        </button>
        <button
          (click)="decline(game.gameInvitationId!, game.gameId)"
          class="button-secondary-style or-h-24-px or-head-xs or-w-112-px">
          Nie gram
        </button>
      </div>
    </div>
  }
}
